import { useContent } from '../ContentContext';

export default function TopStrip() {
  const { company } = useContent();
  if (!company?.tagline) return null;
  return (
    <div className="top-strip">
      <div className="container">
        <span>{company.tagline}</span>
      </div>
    </div>
  );
}
